<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventTypeFields"
        title-table="Campo Tipo de Evento"
        module="eventTypeFieldSettingsModule"
        sort-name="nome"
        add-permission="ROLE_CORE_INSERIR"
        view-permission="ROLE_CORE_CONSULTAR"
        edit-permission="ROLE_CORE_ATUALIZAR"
        delete-permission="ROLE_CORE_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <EventTypeFieldForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import EventTypeFieldForm from './form/EventTypeFieldForm.vue'

export default {
  name: 'EventTypeFieldSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventTypeFieldForm,
  },
  computed: {
    ...mapState('eventTypeFieldSettingsModule', {
      listaEventTypeFields: state => state.listaEventTypeFields,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Tipo',
          field: 'tipoCampo',
        },
        {
          label: 'Tipo Evento',
          field: 'tipoEvento.nome',
        },
        {
          label: 'Ação',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('eventTypeFieldSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
